import { getBuildingLivingTypes } from '../../../api'
import { getItemsFromApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { toBuildingTypeSelectItems } from '../Building.utils'

import { BUILDING_TYPE_SELECT_DROPDOWN_FLOATING_CONFIG } from './BuildingTypeSelect.constants'

function BuildingTypeSelect({
  Control = InputSelectControl,
  dropdownFloatingConfig = BUILDING_TYPE_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData = getBuildingLivingTypes,
  getDataItems = getItemsFromApiResponse,
  toPreparedItems = toBuildingTypeSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default BuildingTypeSelect
